module.exports = __webpack_public_path__ + "static/img/wx-qr-code.31b265d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx-qr-code.png
// module id = k3Aw
// module chunks = 10